import C from "../../../_virtual/index2.mjs";
import { useState as d, useMemo as i, useEffect as m } from "react";
const l = ({
  color: t,
  onChange: n,
  delay: o = 300
}) => {
  const [u, c] = d(t), e = i(
    () => C((r) => {
      typeof n < "u" && n(r);
    }, o),
    [o, n]
  );
  m(() => (c(t), () => {
    e.cancel();
  }), [t, e]);
  function f(r) {
    c(r), e(r);
  }
  function s() {
    return e.flush(), u;
  }
  return {
    currentColor: u,
    updateColor: f,
    syncCurrentColor: s
  };
};
export {
  l as useDebouncedColorChange
};
